import { LuFlame, LuQrCode } from 'react-icons/lu';
import {
  FiActivity,
  FiAlertCircle,
  FiAlertOctagon,
  FiAlertTriangle,
  FiAlignCenter,
  FiAlignLeft,
  FiAlignRight,
  FiArchive,
  FiArrowDownRight,
  FiArrowLeft,
  FiArrowRight,
  FiArrowUpRight,
  FiAward,
  FiBarChart,
  FiBell,
  FiBellOff,
  FiBold,
  FiBox,
  FiBriefcase,
  FiCalendar,
  FiCamera,
  FiCheck,
  FiCheckCircle,
  FiCheckSquare,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiCircle,
  FiClock,
  FiCode,
  FiColumns,
  FiCopy,
  FiCornerUpLeft,
  FiCornerUpRight,
  FiCpu,
  FiCreditCard,
  FiDatabase,
  FiDollarSign,
  FiDownload,
  FiEdit,
  FiExternalLink,
  FiEye,
  FiEyeOff,
  FiFacebook,
  FiFile,
  FiFileText,
  FiFilter,
  FiFlag,
  FiFolder,
  FiFolderPlus,
  FiGitBranch,
  FiGitMerge,
  FiGlobe,
  FiGrid,
  FiHash,
  FiHeadphones,
  FiHeart,
  FiHelpCircle,
  FiHome,
  FiImage,
  FiInbox,
  FiInfo,
  FiInstagram,
  FiItalic,
  FiKey,
  FiLayers,
  FiLink,
  FiLinkedin,
  FiList,
  FiLoader,
  FiLock,
  FiLogOut,
  FiMail,
  FiMapPin,
  FiMaximize,
  FiMenu,
  FiSidebar,
  FiMessageCircle,
  FiMessageSquare,
  FiMic,
  FiMinimize,
  FiMinus,
  FiMonitor,
  FiMoon,
  FiMoreHorizontal,
  FiMoreVertical,
  FiMousePointer,
  FiMusic,
  FiPackage,
  FiPaperclip,
  FiPause,
  FiPauseCircle,
  FiPercent,
  FiPhone,
  FiPieChart,
  FiPlay,
  FiPlus,
  FiPower,
  FiRefreshCw,
  FiRepeat,
  FiRotateCcw,
  FiRotateCw,
  FiSave,
  FiSearch,
  FiSend,
  FiServer,
  FiSettings,
  FiShare,
  FiShield,
  FiShoppingBag,
  FiShuffle,
  FiSkipForward,
  FiSlash,
  FiSliders,
  FiSmartphone,
  FiTablet,
  FiSmile,
  FiSquare,
  FiStar,
  FiStopCircle,
  FiSun,
  FiTag,
  FiTarget,
  FiThermometer,
  FiYoutube,
  FiToggleLeft,
  FiToggleRight,
  FiTool,
  FiTrash,
  FiTrendingDown,
  FiTrendingUp,
  FiTruck,
  FiType,
  FiUnderline,
  FiUnlock,
  FiUpload,
  FiUser,
  FiUserCheck,
  FiUserPlus,
  FiUsers,
  FiVideo,
  FiWifi,
  FiWifiOff,
  FiX,
  FiXCircle,
  FiZap,
  FiZoomIn,
  FiZoomOut,
} from 'react-icons/fi'

import {
  MdDragIndicator,
  MdFormatListNumbered,
  MdFormatStrikethrough,
} from 'react-icons/md'

import { LuBath, LuRuler } from 'react-icons/lu'

import type { IconPack } from '../types'

export const featherPack: IconPack = {
  // Navigation
  'home': FiHome,
  'menu': FiMenu,
  'panel-left': FiSidebar,
  'chevron-down': FiChevronDown,
  'chevron-left': FiChevronLeft,
  'chevron-right': FiChevronRight,
  'chevron-up': FiChevronUp,
  'arrow-left': FiArrowLeft,
  'arrow-right': FiArrowRight,
  'arrow-up-right': FiArrowUpRight,
  'arrow-down-right': FiArrowDownRight,
  'corner-up-left': FiCornerUpLeft,
  'corner-up-right': FiCornerUpRight,
  'external-link': FiExternalLink,
  'log-out': FiLogOut,
  'globe': FiGlobe,
  'map-pin': FiMapPin,

  // Actions
  'plus': FiPlus,
  'minus': FiMinus,
  'x': FiX,
  'check': FiCheck,
  'check-circle': FiCheckCircle,
  'check-square': FiCheckSquare,
  'x-circle': FiXCircle,
  'search': FiSearch,
  'zoom-in': FiZoomIn,
  'zoom-out': FiZoomOut,
  'filter': FiFilter,
  'refresh': FiRefreshCw,
  'rotate-ccw': FiRotateCcw,
  'rotate-cw': FiRotateCw,
  'repeat': FiRepeat,
  'shuffle': FiShuffle,
  'download': FiDownload,
  'upload': FiUpload,
  'share': FiShare,
  'copy': FiCopy,
  'save': FiSave,
  'edit': FiEdit,
  'trash': FiTrash,
  'archive': FiArchive,
  'send': FiSend,
  'drag': MdDragIndicator,
  'maximize': FiMaximize,
  'minimize': FiMinimize,
  'mouse-pointer': FiMousePointer,
  'power': FiPower,

  // Communication
  'mail': FiMail,
  'inbox': FiInbox,
  'message-circle': FiMessageCircle,
  'message-square': FiMessageSquare,
  'phone': FiPhone,
  'video': FiVideo,
  'mic': FiMic,
  'headphones': FiHeadphones,
  'bell': FiBell,
  'bell-off': FiBellOff,

  // Media & Content
  'image': FiImage,
  'camera': FiCamera,
  'file': FiFile,
  'file-text': FiFileText,
  'folder': FiFolder,
  'folder-plus': FiFolderPlus,
  'paperclip': FiPaperclip,
  'link': FiLink,
  'music': FiMusic,
  'play': FiPlay,
  'pause': FiPause,
  'pause-circle': FiPauseCircle,
  'stop-circle': FiStopCircle,
  'skip-forward': FiSkipForward,

  // Data & Analytics
  'bar-chart': FiBarChart,
  'pie-chart': FiPieChart,
  'trending-up': FiTrendingUp,
  'trending-down': FiTrendingDown,
  'activity': FiActivity,
  'award': FiAward,
  'percent': FiPercent,
  'target': FiTarget,
  'database': FiDatabase,
  'grid': FiGrid,
  'columns': FiColumns,
  'list': FiList,
  'list-ordered': MdFormatListNumbered,
  'hash': FiHash,
  'layers': FiLayers,
  'sliders': FiSliders,

  // Users & People
  'user': FiUser,
  'user-plus': FiUserPlus,
  'user-check': FiUserCheck,
  'users': FiUsers,
  'smile': FiSmile,

  // Business & Commerce
  'briefcase': FiBriefcase,
  'shopping-bag': FiShoppingBag,
  'credit-card': FiCreditCard,
  'dollar-sign': FiDollarSign,
  'tag': FiTag,
  'package': FiPackage,
  'truck': FiTruck,
  'box': FiBox,

  // Security & Status
  'lock': FiLock,
  'unlock': FiUnlock,
  'slash': FiSlash,
  'key': FiKey,
  'shield': FiShield,
  'eye': FiEye,
  'eye-off': FiEyeOff,
  'alert-circle': FiAlertCircle,
  'alert-octagon': FiAlertOctagon,
  'alert-triangle': FiAlertTriangle,
  'info': FiInfo,
  'help-circle': FiHelpCircle,
  'flag': FiFlag,
  'circle': FiCircle,
  'square': FiSquare,

  // Settings & Tools
  'settings': FiSettings,
  'tool': FiTool,
  'code': FiCode,
  'cpu': FiCpu,
  'server': FiServer,
  'wifi': FiWifi,
  'wifi-off': FiWifiOff,
  'smartphone': FiSmartphone,
  // Feather não tem QR — glifo do lucide (mesma exceção do `flame`)
  'qr-code': LuQrCode,
  'tablet': FiTablet,
  'thermometer': FiThermometer,
  'youtube': FiYoutube,
  // Feather não tem flame — glyph do lucide (mesmo path do i-flame do mockup DS)
  'flame': LuFlame,
  'toggle-left': FiToggleLeft,
  'toggle-right': FiToggleRight,
  'loader': FiLoader,
  'calendar': FiCalendar,
  'clock': FiClock,

  // Appearance
  'sun': FiSun,
  'moon': FiMoon,
  'heart': FiHeart,
  'star': FiStar,
  'zap': FiZap,

  // Text Formatting
  'bold': FiBold,
  'italic': FiItalic,
  'underline': FiUnderline,
  'strikethrough': MdFormatStrikethrough,
  'type': FiType,
  'align-left': FiAlignLeft,
  'align-center': FiAlignCenter,
  'align-right': FiAlignRight,

  // Version Control
  'git-branch': FiGitBranch,
  'git-merge': FiGitMerge,

  // Social / Brand
  'facebook': FiFacebook,
  'instagram': FiInstagram,
  'linkedin': FiLinkedin,
  'monitor': FiMonitor,

  // Specialty
  'bath': LuBath,
  'ruler': LuRuler,
  'more-horizontal': FiMoreHorizontal,
  'more-vertical': FiMoreVertical,
}
